export default __webpack_public_path__ + "static/media/DashLogo.a2ce37b9.png";